import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

import '../css/blocks/iconlinks.css'

const iSwipers = document.querySelectorAll('.iconlinks-outer .slider');

if (iSwipers) {
    iSwipers.forEach((element) => {
        
        var id = element.id.replace('swiper-', '')
        const swiperid = "#swiper-" + id;
        const spv = element.classList.contains('icon-slider') ? 2 : 3;
        new Swiper(swiperid, {
            modules: [Navigation],
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: "#swiper-next-" + id,
                prevEl: "#swiper-prev-" + id,
                addIcons: false // 👈 This strictly stops Swiper from injecting its custom SVG
            },
            breakpoints: {
                992: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1400: {
                    slidesPerView: spv,
                    spaceBetween: 30
                }
            }
        });
    })
}

